<!--
 * @Description: 我的合同，由index.js 配置引入
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-06-18 13:42:43
 * @LastEditors: luoshoufeng@szkingdom.com
-->
<template>
    <div class="bizcomp-my-contract">
        <div>
            <el-table
                :data="fundContract"
                style="width: 100%"
                :class="
                    'tab-list-tit table-list ' + (fundContract.length > 0 ? 'border-bottom' : '')
                "
                max-height="535"
            >
                <el-table-column
                    prop="fundshortname"
                    label="基金名称"
                    align="center"
                    :formatter="formatterFundName"
                />
                <el-table-column
                    prop="signdate"
                    label="签署日期"
                    align="center"
                    :formatter="formatterSignDate"
                ></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <span class="contract-detail" v-on:click="getContractDetail(scope.row)">
                            合同详情
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog
                title="合同详情"
                :visible.sync="dialogVisible"
                class="prop info-tips"
                width="480px"
            >
                <div class="contract-detail-dialog">
                    <div
                        v-if="contract && Object.keys(contract).length > 0"
                        class="contract-detail-contain"
                    >
                        <div class="contract-detail-name">
                            <img src="@/assets/img/pdf-icon.svg" alt="" />
                            《产品合同》
                        </div>
                        <div class="download-look-contain">
                            <a
                                :href="contract.fileurl"
                                class="download-file"
                                download="产品合同"
                                target="_blank"
                            >
                                下载
                            </a>
                            <a :href="contract.fileurl" class="look-file" target="_blank">查看</a>
                        </div>
                    </div>
                    <div
                        v-if="revealbook && Object.keys(revealbook).length > 0"
                        class="contract-detail-contain"
                    >
                        <div class="contract-detail-name">
                            <img src="@/assets/img/pdf-icon.svg" alt="" />
                            《产品风险揭示书》
                        </div>
                        <div class="download-look-contain">
                            <a
                                :href="revealbook.fileurl"
                                class="download-file"
                                download="产品风险揭示书"
                                target="_blank"
                            >
                                下载
                            </a>
                            <a :href="revealbook.fileurl" class="look-file" target="_blank">查看</a>
                        </div>
                    </div>
                    <div v-if="supplements && supplements.length > 0">
                        <div
                            v-for="(item, index) of supplements"
                            :key="index"
                            class="contract-detail-contain"
                        >
                            <div class="contract-detail-name">
                                <img src="@/assets/img/pdf-icon.svg" alt="" />
                                《产品补充协议》
                            </div>
                            <div class="download-look-contain">
                                <a
                                    :href="item.fileurl"
                                    class="download-file"
                                    download="产品补充协议"
                                    target="_blank"
                                >
                                    下载
                                </a>
                                <a :href="item.fileurl" class="look-file" target="_blank">查看</a>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div
                            v-for="(item, index) in contractInfo.contractList"
                            :key="index"
                            class="contract-detail-contain"
                        >
                            <div class="contract-detail-name">
                                <img src="@/assets/img/pdf-icon.svg" alt="" />
                                《{{ $cache.getDict("220044", item.filetype) }}》
                            </div>
                            <div class="download-look-contain">
                                <a
                                    :href="$util.fileDownloadPath(item.filepath)"
                                    class="download-file"
                                    :download="$cache.getDict('220044', item.filetype)"
                                >
                                    下载
                                </a>
                                <a
                                    :href="$util.fileDownloadPath(item.filepath)"
                                    class="look-file"
                                    target="_blank"
                                >
                                    查看
                                </a>
                            </div>
                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <button class="confirm-btn" v-on:click="dialogVisible = false">确定</button>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import fundApi from "@/api/fund";

export default {
    name: "MyContract",
    components: {},
    mixins: [mixin],
    data() {
        return {
            fundContract: [],
            contract: {},
            revealbook: {},
            supplements: [],
            contractInfo: {},
            dialogVisible: false
        };
    },
    mounted() {
        this.combQueryCustEleSgin();
    },
    methods: {
        async combQueryCustEleSgin() {
            const res = await fundApi.combQueryCustEleSgin();
            this.fundContract = res.data.data;
        },
        async qryContract() {
            const res = await fundApi.viewContract();
            if (res.data) {
                this.fundContract = res.data.data;
            }
        },
        formatterFundName(row, column, value) {
            return `${row.fundshortname || row.fundname}` + "(" + row.fundcode + ")";
        },
        formatterSignDate(row, column, value) {
            return this.$util.fmtDate(value);
        },
        getContractDetail(val) {
            this.contract = {};
            this.revealbook = {};
            this.supplements = [];
            this.contractInfo = {};
            if (val.orderno) {
                this.qryContractOrderDetail(val);
            } else if (val.contractList && val.contractList.length > 0) {
                this.contractInfo = val;
                this.dialogVisible = true;
            } else {
                this.$message.warning("暂无相关信息");
            }
        },
        async qryContractOrderDetail(val) {
            const res = await fundApi.qryContractOrderDetail({
                fundcode: val.fundcode,
                orderno: val.orderno
            });
            if (res.data) {
                if (res.data.contract) {
                    this.contract = res.data.contract;
                }
                if (res.data.revealbook) {
                    this.revealbook = res.data.revealbook;
                }
                if (res.data.supplements && res.data.supplements.length > 0) {
                    this.supplements = res.data.supplements;
                }
                this.dialogVisible = true;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.bizcomp-my-contract {
    width: 1200px;
    height: 575px;
    background: #ffffff;
    box-sizing: border-box;
    border: 1px solid #f1f1f1;
    padding: 20px;
    margin-bottom: 20px;
    .table-list {
        font-size: 14px;
        font-weight: 350;
        color: #333333;
        .contract-detail {
            cursor: pointer;
        }
    }
    .contract-detail-dialog {
        padding: 20px 20px;
        font-size: 15px;
        .contract-detail-contain {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 50px;
            .contract-detail-name {
                display: flex;
                align-items: center;
                width: 60%;
            }
            .download-look-contain {
                width: 40%;
                text-align: right;
            }
            .download-file {
                font-size: 12px;
                font-weight: 350;
                color: #1579d7;
                cursor: pointer;
            }
            .look-file {
                font-size: 12px;
                font-weight: 350;
                color: #1579d7;
                cursor: pointer;
                margin-left: 20px;
            }
        }
        .dialog-footer {
            margin-top: 10px;
            text-align: center;
            .confirm-btn {
                width: 80px;
                height: 35px;
                line-height: 35px;
                border-radius: 2px;
                background: #e60012;
                cursor: pointer;
                font-size: 16px;
                font-weight: 500;
                text-align: center;
                color: #ffffff;
                border: none;
            }
        }
    }
    :deep(.el-table) {
        th {
            background: #f9f9f9;
            border: 1px solid #eaeaea;
        }
        td {
            border: 1px solid #eaeaea;
        }
    }
    .el-table::before {
        height: 0;
    }
    .el-table--fit {
        margin: 0 !important;
    }
    :deep(.gutter) {
        border: none !important;
        background-color: #ffffff !important;
    }
}
.border-bottom {
    border-bottom: 1px solid #eaeaea;
}
</style>
